import { createWebHistory, createRouter } from "vue-router";

const routes = [
  {
    path: "/",
    redirect: "/auth-login",
  },
  {
    path: "/auth-login",
    name: "auth-login",
    alias: ["/login", "/signin", "/sign-in"],
    component: () => import("@/pages/auth-pages/auth-login.vue"),
  },
  {
    path: "/auth-signup",
    name: "auth-signup",
    alias: ["/signup", "/register", "/sign-up"],
    component: () => import("@/pages/auth-pages/auth-signup.vue"),
  },
  {
    path: "/auth-re-password",
    name: "auth-re-password",
    component: () => import("@/pages/auth-pages/auth-re-password.vue"),
  },
  {
    path: "/auth-lock-screen",
    name: "auth-lock-screen",
    component: () => import("@/pages/auth-pages/auth-lock-screen.vue"),
  },
  {
    path: "/candidates",
    name: "candidates-dashboard",
    component: () => import("@/pages/candidates-dashboard.vue"),
  },
  {
    path: "/:catchAll(.*)",
    redirect: "/auth-login",
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;